import { Injectable } from '@angular/core';
import { FundDetailService } from '@components/products/services/fund-detail.service';
import {
  FundPerformanceCummulativeState,
  ProductDetailConfiguration,
} from '@types';
import { Observable, Subject } from 'rxjs';
import FundPerformanceCummulativeQuery from '@graphql/fund-performance/fund-performance-cummulative.graphql';
import { Product, ShareClass } from '@components/products/models';

@Injectable({
  providedIn: 'root',
})
export class FundPerformanceCummulativeService {
  private state: FundPerformanceCummulativeState;
  private cummulativeState$: Subject<FundPerformanceCummulativeState>;
  constructor(private fundDetailService: FundDetailService) {
    this.state = {
      inceptionDate: null,
      sinceInceptionReturnDate: null,
    };
    this.cummulativeState$ = new Subject();
  }

  /**
   * Return fund performance annualized state as observable.
   */
  getCummulativeState$(): Observable<FundPerformanceCummulativeState> {
    return this.cummulativeState$.asObservable();
  }
  /**
   * Fetch the fund annualized performance from PDS and initialize state.
   * @param productDetailConfiguration product detail configuration from bloomreach
   */
  populate(productDetailConfiguration: ProductDetailConfiguration): void {
    this.fundDetailService
      .register(FundPerformanceCummulativeQuery, {
        fundId: productDetailConfiguration.fundId,
      })
      .subscribe(
        (fundDetail: Product) => {
          if (fundDetail.fundInceptionDate) {
            this.state.isLoaded = true;
            this.state.inceptionDate = fundDetail.fundInceptionDate;
          } else {
            this.state.isLoaded = false;
          }

          this.cummulativeState$.next(this.state);
        },
        (error) => {
          // logger.error(`Error in invoking fund detail service: ${error}`);

          this.cummulativeState$.error(error);
        }
      );
  }
}
